import { DeleteOutline, InfoOutlined, PhoneOutlined, MailOutline, PhoneIphoneOutlined } from '@lichtblick/icons';
import { Colors, TextVariants } from '@lichtblick/theme';
import { ApprovalState, UserPayloadModel, GetAppointmentWorkforceUserPayloadModel } from '@lichtblick/types';
import { formatName } from '@lichtblick/utils';

import { ContactRow, Container, Controls, NamePlate } from './TeamMemberRow.styles';

import { Chip } from '../Chip';
import { IconButton } from '../IconButton';
import { PopoverComponent } from '../Popover';
import { Text } from '../Text';

type TeamMemberRowProps = {
  craftsman: UserPayloadModel | GetAppointmentWorkforceUserPayloadModel;
  handleRemove: () => void;
  shouldHideDelete?: boolean;
};

export const TeamMemberRow = ({ craftsman, handleRemove, shouldHideDelete }: TeamMemberRowProps) => {
  return (
    <Container>
      <NamePlate>
        <Text $variant={TextVariants.title.l}>
          {formatName({ firstName: craftsman.firstName, lastName: craftsman.lastName })}
        </Text>
        <Text $variant={TextVariants.body.xs} color={Colors.gray['100']}>
          Branch | Role skill
        </Text>
      </NamePlate>

      <Controls>
        <Chip shouldShowIcon={false} size="small" text="Present" variant={ApprovalState.ClientApproved} />
        <PopoverComponent
          align="end"
          content={
            <>
              {craftsman.__typename === 'GetAppointmentWorkforceUserPayloadModel' && (
                <>
                  <ContactRow>
                    <PhoneIphoneOutlined color="primary" height={16} />
                    <Text $variant={TextVariants.body.sMedium} color={Colors.gray['100']}>
                      {craftsman.mobilePhone ?? '-'}
                    </Text>
                  </ContactRow>
                  <ContactRow>
                    <PhoneOutlined color="primary" height={16} />
                    <Text $variant={TextVariants.body.sMedium} color={Colors.gray['100']}>
                      {craftsman.phone ?? '-'}
                    </Text>
                  </ContactRow>
                </>
              )}
              <ContactRow>
                <MailOutline color="primary" height={16} />
                <Text $variant={TextVariants.body.sMedium} color={Colors.gray['100']}>
                  {craftsman.eMail ?? '-'}
                </Text>
              </ContactRow>
            </>
          }
          trigger={<InfoOutlined color="primary" />}
        />
        {!shouldHideDelete && (
          <IconButton icon={<DeleteOutline color="disabled" />} onClick={handleRemove} variant="ghost" />
        )}
      </Controls>
    </Container>
  );
};
